import { useEffect, useRef, useState, useMemo } from "react";
import io from "socket.io-client";

const useSocket = (serverUrl, options = {}) => {
  const socketRef = useRef(null);
  const [isConnected, setIsConnected] = useState(false);

  const memoizedOptions = useMemo(() => options, [JSON.stringify(options)]);

  useEffect(() => {
    const socket = io(serverUrl, memoizedOptions);
    socketRef.current = socket;

    socket.on("connect", () => {
      setIsConnected(true);
      console.log("Socket connected:", socket.id);
    });

    socket.on("disconnect", () => {
      setIsConnected(false);
      console.log("Socket disconnected");
    });

    return () => {
      socket.disconnect();
      console.log("Socket connection cleaned up");
    };
  }, [serverUrl, memoizedOptions]);

  return { socket: socketRef.current, isConnected };
};

export default useSocket;
